module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAArElEQVRIS83VOw7CMBAE0FnX3IuGOyBRBAlBzpKEJqYAxCU4FycwShsJ2zPWSrj3PP/Wa3Ae5pyPLHC9vbZACpdu/1YXkgXG+fGBYWNIp/54iAqSBYZ4PxtsApBUpHgHU3z2CWlQkSKwHEsLUgW0INWAilCAgtAAi0jAGgkWdr+K8T8B5tnSO2DCl6OkADacApTwakANrwJawouA+3ft3nDcW6bSItdzqDpQwC9KxaAZawzDYgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/icon-right-gray.png
// module id = 7jgB
// module chunks = 4